import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { EditUserFormComponent } from 'src/app/components/users/edit-user-form/edit-user-form.component';
import { UpdateUser, UpdateUserDefaultValues } from 'src/app/components/users/update-user';
import { UserListDefaultValues, UsersList } from 'src/app/components/users/user-list';
import { ToastService } from 'src/app/services/toast-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.scss'],
    standalone: false
})
export class EditUserComponent {

  userdbid: string = '';
  applicationRoles: any[] = [];
  updateUser: UpdateUser = UpdateUserDefaultValues()
  roleStates: { [key: number]: boolean } = {};
  pageName=CheckPageAccess.EDITUSER
  constructor(private userservice: UserService, private route: ActivatedRoute, private toastservice: ToastService, private router: Router) { }

  ngOnInit(): void {
    this.route.params.subscribe((param) => {
      this.userdbid = param['id'];
      this.userservice.getApplicationRolesForUpdateUser(this.userdbid).subscribe({
        next: (roles) => {
          this.applicationRoles = roles
          this.userservice.getUserDetailsForUpdate(this.userdbid).subscribe({
            next: (response) => {
              this.updateUser = response;
             
            }
          })
        }
      })
    }) 
  }
  
  udpateUser() {
    console.log(this.updateUser)
    this.userservice.updateUser(this.updateUser).subscribe(
      {
        next: (response) => {
          this.toastservice.showMessage("User Updated Successfully");
          this.router.navigateByUrl('/user-list');
        }
      }
    )
  }

  isItemChecked(item: any, selectedItems: any[]): boolean {    
		if (selectedItems === undefined)
			return false;
		return selectedItems.some((selectedItem) => selectedItem === item);
	}
 

  onRolesCheckboxChange(id: number, event:Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.roleStates[id] = isChecked;
    if (isChecked) {
      this.updateUser.applicationRoles.push(id);
    } else {
      const index = this.updateUser.applicationRoles.indexOf(id);
      if (index > -1) {
        this.updateUser.applicationRoles.splice(index, 1);
      }
    }
  }

  initializeRoleStates() {
    this.applicationRoles.forEach(role => {
      this.roleStates[role.id] = this.updateUser.applicationRoles.includes(role.id);
    });
  }
}
